<app-facet-expansion-panel
  [facetKey]="componentData.facetKey"
  [count]="selectedFacets.length"
  [expanded]="expanded"
  [blockName]="blockName"
  [id]="facetId"
  [attr.data-automation-id]="componentData.facetKey"
  *ngIf="facets && facets.totalResults && facets.totalResults > 0 || (facetId === 'concept' || facetId === 'agent' || facetId === 'location')"
>
  <div>
    <div class="spinner-container" *ngIf="isLoading | async; else facetTemplate">
      <div class="spinner-border text-primary"
           role="status"
           data-automation-id="facet-spinner">
        <span class="sr-only" translate>Loading...</span>
      </div>
    </div>
    <ng-template #facetTemplate>
      <fieldset class="facet">
          <legend class="sr-only">{{facetName}}</legend>
        <div *ngFor="let facet of facetsToShow; let i = index; trackBy: trackById" class="facet-line">
            <app-facet-filter [facet]="facet" class="filter"></app-facet-filter>
        </div>
        <app-facets-button (showFewer)="onShowFewer()"
                           (showMore)="onShowMore()"
                           (showAll)="onShowAll()"
                           [totalResults]="facets?.totalResults"
                           [showedFacetsCount]="facetsToShow?.length"
                           [showAllAvailable]="isShowAllAvailable"
                           [facetName]="facetName"
                           [facetPluralName]="facetPluralName"
                           [leftCount]="facetsLeftCount"
                           data-automation-id="facet-button"></app-facets-button>
      </fieldset>
    </ng-template>
  </div>
</app-facet-expansion-panel>
